﻿import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AppConfig } from 'app/app.config';

@Component({
    selector: 'inactivity-timeout',
    template: `<div id="lightboxes" style="display:block" *ngIf="show" >
		         <div class="panel" id="lb_inactivity" style="display:block">
			        <div class="lightboxHeader2"> Inactivity Alert</div>                    
			        <div class="lightboxContent">
                        Due to inactivity your online session will expire in {{countdown}} minutes. Click "Stay Logged In" to continue working on this page or click "Log Out" to end your session now. Any changes not saved will be lost.
                    </div>			        	
			        <div class="row">
                       <div class="half">
                            <input name="close" type="button" value="Log Out" class="btnHPD treasurer floatLeft actionCloseLightbox" (click) = "logout()">
                       </div>
                       <div class="half">
                            <input name="yes" type="button" value="Stay Logged In" class="btnHPD floatRight actionCloseLightbox" (click)="stayLoggedIn()" [focus]="true">
                      </div>
                    </div>
		        </div>
	        </div>`
})

export class TimeoutComponent {
    @Input() show: boolean;
    @Input() countdown: string;
    @Output() stayLogged: EventEmitter<any> = new EventEmitter<any>();

    constructor(private idle: Idle) { }

    stayLoggedIn() {
        this.stayLogged.emit('staylogged');
        this.show = false;
    }

    logout() {
        this.idle.watch();
        window.location.href = AppConfig.config.cpuiLogoutUrl;
    }
}

